import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { AgendaService } from '../services/agenda.service';
import { AlertComponent } from "../../../../alert/alert.component";
import { LoadingModalComponent } from "../../../../loading-modal/loading-modal.component";
import { MatIcon } from "@angular/material/icon";

enum DaysOfWeek {
  Domingo = 0,
  Segunda = 1,
  Terca = 2,
  Quarta = 3,
  Quinta = 4,
  Sexta = 5,
  Sabado = 6,
}

@Component({
  selector: 'app-editar-agenda',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, AlertComponent, LoadingModalComponent, MatIcon],
  templateUrl: './editar-agenda.component.html',
  styleUrls: ['./editar-agenda.component.scss'],
})
export class EditarAgendaComponent implements OnInit {
  @Input() objectData: any;
  @Output() closeModal: EventEmitter<void> = new EventEmitter();
  @ViewChild(AlertComponent) alertComponent!: AlertComponent;
  @ViewChild(LoadingModalComponent) loadingComponent!: LoadingModalComponent;

  public formEdit!: FormGroup;

  constructor(private fb: FormBuilder, private readonly agendaService: AgendaService) {}

  ngOnInit() {
    const sortedConfigs = [...this.objectData.ScheduleConfigs].sort(
      (a, b) => a.dayOfWeek - b.dayOfWeek
    );

    this.formEdit = this.fb.group({
      id: [this.objectData.id, [Validators.required]],
      name: [this.objectData.name, [Validators.required]],
      configSchedule: this.fb.array(
        sortedConfigs.map((conf: any) =>
          this.fb.group({
            dayOfWeek: [conf.dayOfWeek],
            isActive: [conf.isActive],
            startHour: [conf.startHour],
            endHour: [conf.endHour],
            appointmentDuration: [conf.appointmentDuration],
            hasBreak: [conf.hasBreak],
            breakStart: [conf.breakStart],
            breakEnd: [conf.breakEnd],
          })
        )
      ),
    });

    console.log(this.formEdit.value);
  }

  getDayOfWeek(day: number): string {
    return DaysOfWeek[day];
  }

  get configsArray(): FormArray {
    return this.formEdit.get('configSchedule') as FormArray;
  }

  handleCloseModal() {
    this.closeModal.emit();
  }

  handleSubmit(){
    this.loadingComponent.activeLoading();
    console.log(this.formEdit.value);
    this.agendaService.updateSchedule(this.formEdit.value).subscribe((response: any)=> {
      console.log(response);
      
      this.alertComponent.showAlert("Agenda atualizada com sucesso!", 'success');
      this.loadingComponent.inactiveLoading();
      this.handleCloseModal();
    }, (error: any)=> {
      console.log(error);
      this.alertComponent.showAlert("Erro ao atualizar agenda!",'error');
      this.loadingComponent.inactiveLoading();
    })
  }
}
